module.exports = __webpack_public_path__ + "static/media/tw.b76bad5a.svg";